import SystemResult from './SystemResult';

export default SystemResult;
